(function () {
	if (!window.IMS) {
		window.IMS = {};
	}

	IMS.Disclaimer = class Disclaimer {
		/**
		 * @param {Object} options
		 * @param {string} options.baseClass
		 * @param {function} options.afterDismiss
		 * @param {string} [options.linkLabel] Link label key
		 * @param {string} [options.linkTextLabel] Link text label key
		 * @param {string} [options.textLabel] Text label key
		 * @param {string} [options.dismissLabelKey] Dismiss button label key
		 * @param {boolean} [options.alwaysDisplay]  True to always attempt to add the banner even if others are present
		 * @param {boolean} [options.displayOnTop]  True to appear directly on top of the content
		 * @param {boolean} [options.template]  Content template to use
		 */
		constructor(options) {
			const getLabel = window.IMS?.Labels
				? IMS.Labels.getLabel.bind(IMS.Labels)
				: (labelKey) => $(`script#${labelKey}`).html();

			this.alwaysDisplay = options.alwaysDisplay;
			this.displayOnTop = options.displayOnTop;
			this.baseClass = options.baseClass;
			this.afterDismiss = options.afterDismiss;

			const link = getLabel(options.linkLabel);
			const linkText = getLabel(options.linkTextLabel);
			const dismiss = getLabel(options.dismissLabelKey);
			const text = getLabel(options.textLabel);
			if (options.template) {
				this.template = options.template;
			} else {
				this.template =
					`<div class="${this.baseClass} disclaimer-banner clearfix">` +
					'<button class="btn-ims btn-ims--small btn-ims--ghost-option btn-ims--ghost-option-primary disclaimer-banner__btn" id="btnDismiss">' +
					'<div class="btn-ims__inner"><span>' +
					dismiss +
					'</span></div></button>' +
					'<div>' +
					text +
					' <a class="disclaimer-banner__link" href="' +
					link +
					'" target="_blank" rel="noopener">' +
					linkText +
					'</a></div>' +
					'</div>';
			}
		}

		init() {
			const $currentBanner = $('.disclaimer-banner');
			if (!this.alwaysDisplay && $currentBanner.length > 0) {
				// A higher priority banner is already visible (e.g. cookie policy)
				return;
			}

			let $bodyEl = $('body');
			$bodyEl.prepend(this.template);
			this.$disclaimerEl = $('.' + this.baseClass);
			this.$dismissBtnEl = this.$disclaimerEl.find('.disclaimer-banner__btn');
			let configs = [];
			configs = this.repositionContent();
			this.bindEvents(configs);
			this.applyStyle(configs);
		}

		repositionContent() {
			let configs = [];

			if (this.displayOnTop) {
				return configs;
			}

			let $bodyEl = $('body');
			if (!$bodyEl.hasClass('authentication-page')) {
				let $mainHeaderEl = $('.main-header');
				let $mainMenuEl = $('.main-menu');
				configs = [
					{
						style: 'top',
						$el: $mainHeaderEl,
						value: parseInt($mainHeaderEl.css('top')),
					},
					{
						style: 'top',
						$el: $mainMenuEl,
						value: parseInt($mainMenuEl.css('top')),
					},
				];
				let pageType = $('.page')
					.attr('class')
					.match(/([a-zA-Z\-]+)\-page/);
				if (pageType !== null) {
					pageType = pageType[1];
					switch (pageType) {
						case 'items':
							this.initItemsPage(configs);
							break;
						case 'item':
							this.initItemPage(configs);
							break;
						case 'map':
							this.initMapPage(configs);
							break;
						case 'activity':
							this.initActivityPage(configs);
							break;
						case 'analytics-items':
							this.initAnalyticsItemsPage(configs);
							break;
						case 'analytics-report':
							this.initAnalyticsReportPage(configs);
							break;
						case 'analytics-widget':
							this.initAnalyticsWidgetPage(configs);
							break;
					}
				} else if ($bodyEl.hasClass('home-page')) {
					this.initHomePage(configs);
				}
			}
			return configs;
		}

		initHomePage(configs) {
			configs.push(this.getMarginTopConfig('.home'));
		}

		initItemsPage(configs) {
			configs.push(this.getTopConfig('.items-header'));
			configs.push(this.getMarginTopConfig('.items-page'));
		}

		initItemPage(configs) {
			configs.push(this.getTopConfig('.item-header'));
			configs.push(this.getMarginTopConfig('.item-page'));
			configs.push(this.getTopConfig('.map-page-section'));
		}

		initMapPage(configs) {
			let mapPageEl = $('.map-page');
			let value = parseInt(mapPageEl.css('marginTop'));
			configs.push({
				style: 'marginTop',
				$el: mapPageEl,
				value: function () {
					if (!value) {
						value = parseInt(mapPageEl.css('marginTop'));
					}
					return value;
				},
			});
		}

		initActivityPage(configs) {
			configs.push(this.getMarginTopConfig('.activity-page'));
		}

		initAnalyticsItemsPage(configs) {
			configs.push(this.getMarginTopConfig('.analytics-items-page'));
		}

		initAnalyticsReportPage(configs) {
			configs.push(this.getMarginTopConfig('.analytics-report-page'));
		}

		initAnalyticsWidgetPage(configs) {
			configs.push(this.getMarginTopConfig('.analytics-widget-page'));
		}

		getMarginTopConfig(queryString) {
			let $el = $(queryString);
			return {
				style: 'marginTop',
				$el: $el,
				value: parseInt($el.css('marginTop')),
			};
		}

		getTopConfig(queryString) {
			let $el = $(queryString);
			return {
				style: 'top',
				$el: $el,
				value: parseInt($el.css('top')),
			};
		}

		applyStyle(configs) {
			let disclaimerHeight = this.$disclaimerEl.outerHeight();
			_.each(configs, (config) => {
				let value = config.value;
				if (_.isFunction(config.value)) {
					value = config.value();
				}
				config.$el.css(config.style, value + disclaimerHeight + 'px');
			});
		}

		bindEvents(configs) {
			if (!this.displayOnTop) {
				this.bindedOnResize = _.throttle(_.bind(this.applyStyle, this, configs), 300);
				$(window).on('resize', this.bindedOnResize);
			}
			this.bindedDismissClick = _.bind(this.onDismiss, this, configs);
			this.$dismissBtnEl.on('click', this.bindedDismissClick);
		}

		onDismiss(configs) {
			this.$disclaimerEl.remove();
			if (!this.displayOnTop) {
				$(window).off('resize', this.bindedOnResize);
				this.undoStyle(configs);
			}
			this.$dismissBtnEl.off(this.bindedDismissClick);
			this.afterDismiss();
		}

		undoStyle(configs) {
			_.each(configs, (config) => {
				config.$el.css(config.style, '');
			});
		}
	};
})();
